module.exports = __webpack_public_path__ + "static/Booklet-350w-06-7594d8fd8c4888475270a598823cf0e3.png";